<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faDownload,faCheckCircle,faClose } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    export let params = {};
    let txn = ''
    let loading = true


    let dataMember
    let isMember = false
    let dataDeposit
    let spBlock = false
    let dataSlip
    let vTimer = "00"
    let countDownDate = 0
    let isopenTimer = true
    let xcc

    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataMember = json.payload
            isMember = true
		}
        loading = false
    }
    async function getDeposit() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getdepositbyid", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({txn:txn})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            getMember()
            dataDeposit = json.payload
            dataSlip = JSON.parse(json.payload.dep.slip_url)
            countDownDate = Number(json.payload.dep.transaction_end)*1000
            // xTimer()
            if(dataDeposit.dep.status=='W'){
                xcc = setInterval(xTimer,1000)
                setTimeout(() => {
                    getDeposit2()
                }, 10000);
            }
		}
        // loading = false
    }

    async function getDeposit2() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getdepositbyid", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({txn:txn})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataDeposit = json.payload
            dataSlip = JSON.parse(json.payload.dep.slip_url)
            if(dataDeposit.dep.status=='W'){
                setTimeout(() => {
                    getDeposit2()
                }, 10000);
            }
		}
        // loading = false
    }
    function xTimer() {
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        vTimer = minutes+":"+seconds
        if(distance<0){
            isopenTimer = false
            clearInterval(xcc)
        }
    }
    let promise
    $: {

        if (params && params.txn) {
            txn = params.txn
            promise = getDeposit()
            // getMember()
        } 
    }

    
    let textarea;
	async function copyNumber(){
		textarea.select();
		document.execCommand('copy');
	}
    // getMember()

</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-3" ><h4 style=" background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;">ฝากเงิน</h4></div>
    <div class="col-12 pb-5" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        

        {#if dataDeposit.dep.status == 'S'}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                <div class="row mb-3">
                    <div class="col-3 text-center" ></div>
                    <div class="col-6 text-center" >
                        <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                    </div>
                    <div class="col-3 text-center" ></div>
                </div>
                <Fa icon={faCheckCircle} size="3x" class="text-white"/>
                <h5 class="text-success">ชำระเงินสำเร็จ</h5>
            </div>
        </div>
        {/if}
        {#if !isopenTimer}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                <div class="row mb-3">
                    <div class="col-3 text-center" ></div>
                    <div class="col-6 text-center" >
                        <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                    </div>
                    <div class="col-3 text-center" ></div>
                </div>
                <Fa icon={faClose} size="3x" class="text-white"/>
                <h5 class="text-danger">หมดเวลาทำรายการ</h5>
            </div>
        </div>
        {/if}

        {#if dataDeposit.dep.status == 'W'}
        {#if isopenTimer}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                
                <div class="row">
                    <div class="col-3 text-center" ></div>
                    <div class="col-6 text-center" >
                        <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                    </div>
                    <div class="col-3 text-center" ></div>
                    <div class="col-sm-1 text-center" ></div>
                    <div class="col-12 col-sm-10 text-center mt-3" >
                        <div class="card mt-2 bg-black">
                            <div class="card-body text-center">
                                <img src="./build/images/bank/{dataSlip.bankName.toLowerCase()}.png" class="img-fluid" style="max-width: 30%;">
                                {#if dataSlip.bankName == 'KTB'}
                                <h6 class="mt-2 text-warning">ธนาคารกรุงไทย</h6>
                                {/if}
                                {#if dataSlip.bankName == 'KBANK'}
                                <h6 class="mt-2 text-warning">ธนาคารกสิกรไทย</h6>
                                {/if}
                                {#if dataSlip.bankName == 'SCB'}
                                <h6 class="mt-2 text-warning">ธนาคารไทยพานิช</h6>
                                {/if}
                                <h6 class="text-white">{dataSlip.bankAccountName}</h6>
                                <h5 class="mb-4 text-white">{dataSlip.bankAccountNumber} 
                                    
                                    <Clipboard
                                    text= {dataSlip.bankAccountNumber}
                                    let:copy
                                    on:copy={() => {
                                        Swal.fire(`คัดลอกแล้ว`)
                                    }}>
                                    <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                                    </Clipboard>
                                
                                </h5>
                                <h6 class="text-white">ยอด <b class="text-info">{Number(dataDeposit.dep.transaction_total.toFixed(2)).toLocaleString("en-US")}</b> บาท</h6>
                                <!-- <small class="text-info ">***กรุณาตรวจสอบเลขบัญชีทุกครั้งก่อนทำการโอน</small> -->
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2 text-center" ></div>
                    <div class="col-12 text-center mt-2" >
                        <h6 class="text-white">เหลือเวลา <b class="text-danger">{vTimer}</b></h6>
                    </div>
                    
                    <div class="col-12  mt-3" >
                        <p class="text-white">***กรุณาใช้ธนาคารนี้ในการโอนเงิน เท่านั้น</p>
                        <div class="card bg-black" style="border:1px solid white;">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-3">
                                        <img src="./assets/icon/bank/{dataDeposit.bank.bankcode}.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                                    </div>
                                    <div class="col-8 text-start text-white">
                                        <h6>{dataDeposit.bank.member_acc}</h6>
                                        <h6>{dataMember.member.member_name}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/if}
        {/if}



        {/if}
        
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-deposits">
        <HeaderThemes/>
        
        <div class="col-12 pb-5" style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
            </div>
            {/if}
            {#if !loading}
        

            {#if dataDeposit.dep.status == 'S'}
            <div class="card mt-5 bg-black">
                <div class="card-body text-center">
                    <div class="row mb-3">
                        <div class="col-3 text-center" ></div>
                        <div class="col-6 text-center" >
                            <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                        </div>
                        <div class="col-3 text-center" ></div>
                    </div>
                    <Fa icon={faCheckCircle} size="3x" class="text-white"/>
                    <h5 class="text-success">ชำระเงินสำเร็จ</h5>
                </div>
            </div>
            {/if}
            {#if !isopenTimer}
            <div class="card mt-5 bg-black">
                <div class="card-body text-center">
                    <div class="row mb-3">
                        <div class="col-3 text-center" ></div>
                        <div class="col-6 text-center" >
                            <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                        </div>
                        <div class="col-3 text-center" ></div>
                    </div>
                    <Fa icon={faClose} size="3x" class="text-white"/>
                    <h5 class="text-danger">หมดเวลาทำรายการ</h5>
                </div>
            </div>
            {/if}

            {#if dataDeposit.dep.status == 'W'}
            {#if isopenTimer}
            <div class="card mt-5 bg-black">
                <div class="card-body text-center">
                    
                    <div class="row">
                        <div class="col-3 text-center" ></div>
                        <div class="col-6 text-center" >
                            <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                        </div>
                        <div class="col-3 text-center" ></div>
                        <div class="col-sm-1 text-center" ></div>
                        <div class="col-12 col-sm-10 text-center mt-3" >
                            <div class="card mt-2 bg-black">
                                <div class="card-body text-center">
                                    <img src="./build/images/bank/{dataSlip.bankName.toLowerCase()}.png" class="img-fluid" style="max-width: 30%;">
                                    {#if dataSlip.bankName == 'KTB'}
                                    <h6 class="mt-2 text-warning">ธนาคารกรุงไทย</h6>
                                    {/if}
                                    {#if dataSlip.bankName == 'KBANK'}
                                    <h6 class="mt-2 text-warning">ธนาคารกสิกรไทย</h6>
                                    {/if}
                                    {#if dataSlip.bankName == 'SCB'}
                                    <h6 class="mt-2 text-warning">ธนาคารไทยพานิช</h6>
                                    {/if}
                                    <h6 class="text-white">{dataSlip.bankAccountName}</h6>
                                    <h5 class="mb-4 text-white">{dataSlip.bankAccountNumber} 
                                        
                                        <Clipboard
                                        text= {dataSlip.bankAccountNumber}
                                        let:copy
                                        on:copy={() => {
                                            Swal.fire(`คัดลอกแล้ว`)
                                        }}>
                                        <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                                        </Clipboard>
                                    
                                    </h5>
                                    <h6 class="text-white">ยอด <b class="text-info">{Number(dataDeposit.dep.transaction_total.toFixed(2)).toLocaleString("en-US")}</b> บาท</h6>
                                    <!-- <small class="text-info ">***กรุณาตรวจสอบเลขบัญชีทุกครั้งก่อนทำการโอน</small> -->
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2 text-center" ></div>
                        <div class="col-12 text-center mt-2" >
                            <h6 class="text-white">เหลือเวลา <b class="text-danger">{vTimer}</b></h6>
                        </div>
                        
                        <div class="col-12  mt-3" >
                            <p class="text-white">***กรุณาใช้ธนาคารนี้ในการโอนเงิน เท่านั้น</p>
                            <div class="card bg-black" style="border:1px solid white;">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-3">
                                            <img src="./assets/icon/bank/{dataDeposit.bank.bankcode}.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                                        </div>
                                        <div class="col-8 text-start text-white">
                                            <h6>{dataDeposit.bank.member_acc}</h6>
                                            <h6>{dataMember.member.member_name}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/if}
            {/if}



            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>